import { z } from 'zod';
import {
  creerEntierOuNull,
  depuisJson,
  entierOuNull,
  projetObligatoire,
  texteFacultatif,
} from './champs';

const nomDeVue = z
  .string({ message: 'saisir_un_nom_de_vue' })
  .trim()
  .min(1, { message: 'saisir_un_nom_de_vue' });

/** Champs saisis 0 ou 1 : leur pattern HTML est déjà « 0|1 ». */
export const zeroOuUn = creerEntierOuNull({
  message: 'saisir_0_ou_1',
  min: 0,
  max: 1,
});

/** Entier positif ou nul, facultatif. */
export const entierPositifOuNull = creerEntierOuNull({
  message: 'saisir_uniquement_des_chiffres',
  min: 0,
});

/** Deux points [x, y] : les coins opposés de la zone affichée. */
const messageCoordonnees = { message: 'format_coordonnees_attendu' };
const point = z.tuple(
  [z.number(messageCoordonnees), z.number(messageCoordonnees)],
  messageCoordonnees
);
export const coordonneesDesBornes = z.preprocess(
  depuisJson,
  z.array(point, messageCoordonnees).length(2, messageCoordonnees)
);

/**
 * Zoom minimum et maximum. null est accepté : une partie des vues existantes
 * portent [null].
 */
const messageZoom = { message: 'format_niveaux_de_zoom_attendu' };
const niveauxDeZoom = z.preprocess(
  depuisJson,
  z.array(z.number(messageZoom).nullable(), messageZoom).max(2, messageZoom)
);

/**
 * Schéma de la charge utile envoyée à la création d'une vue standard (plan et
 * carte, tableau de bord).
 *
 * Le projet et le nom sont exigés, comme ils l'étaient déjà pour les
 * plannings. Le reste est facultatif ; les règles refusent ce que parseInt et
 * IsArrayString laissaient partir en silence : des lettres dans un nombre, une
 * liste mal formée.
 *
 * z.object retirant les clés qu'il ne déclare pas, les 13 clés de la charge
 * utile sont toutes déclarées.
 */
export const schemaNouvelleVue = z.object({
  project_id: projetObligatoire,

  // Liste déroulante alimentée par le glossaire ; pas de liste fermée ici.
  view_type: entierOuNull,

  view_name: nomDeVue,
  view_title: texteFacultatif,
  update_time: entierPositifOuNull,
  view_projection: entierPositifOuNull,
  view_bound_coordinates: coordonneesDesBornes,
  view_zoom_levels: niveauxDeZoom,
  view_copyright: texteFacultatif,
  view_flag_fix_pos: entierPositifOuNull,
  is_clustered: zeroOuUn,
  is_main_view: zeroOuUn,
  is_visible: zeroOuUn,
});

/**
 * Schéma de la charge utile envoyée à la modification d'une vue standard.
 * Même contrat, plus l'identifiant de la vue visée.
 */
export const schemaModificationVue = schemaNouvelleVue.extend({
  view_id: z.coerce.number({ message: 'valeur_invalide' }).int(),
});

/**
 * Plannings (base vie, électrovanne) : seuls le projet et le nom y sont saisis
 * à la main, le reste de la charge utile étant construit par
 * createPlanningPayload.
 */
export const schemaVuePlanning = z.object({
  project_id: projetObligatoire,
  view_name: nomDeVue,
});
